import {
  ButtonComponent,
  DividerComponent,
  LoaderComponent,
} from "@/components";
import {
  useGenerateSoaReportRequestMutation,
  useGetSoaReportQuery,
} from "@/lib/redux";
import { Email, Visibility } from "@mui/icons-material";
import { Box, FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { useEffect, useState } from "react";

const SoaHandler = ({
  tenureArray,
  formik,
  radioListStyle,
  appId,
  setOpenEmailModal,
}) => {
  const [operationType, setOperationType] = useState("");
  const [pollingInterval, setPollingInterval] = useState(3000);
  const [
    generateSoaReport,
    {
      isSuccess: reportGenerated,
      data: soaGeneratedData,
      isFetching: isGeneratingSoaReport,
    },
  ] = useGenerateSoaReportRequestMutation();
  const { data: soaFecthedData, isFetching: isFetchingSoa } =
    useGetSoaReportQuery(
      { appId, requestId: soaGeneratedData?.data?.requestId },
      {
        skip: !soaGeneratedData?.data?.requestId,
        pollingInterval: pollingInterval,
      }
    );

  useEffect(() => {
    if (operationType === "download" && soaFecthedData?.data?.SOA_PDF_BASE64) {
      setPollingInterval(null);
      // Trigger download or display of the PDF
      const link = document.createElement("a");
      link.href = `data:application/pdf;base64,${soaFecthedData.data.SOA_PDF_BASE64}`;
      link.download = `SOA_${appId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [soaFecthedData]);
  useEffect(() => {
    if (reportGenerated && operationType === "download") {
      setPollingInterval(3000);
    }
    if (reportGenerated && operationType === "email") {
      formik.setFieldValue("requestId", soaGeneratedData?.data?.requestId);
      setOpenEmailModal(true);
      setPollingInterval(null);
    }
  }, [reportGenerated]);

  const isLoading = isFetchingSoa || isGeneratingSoaReport;

  return (
    <Stack>
      <LoaderComponent open={isLoading} />
      <RadioGroup
        defaultValue={0}
        name="period"
        value={formik?.values?.period}
        onChange={formik.handleChange}
        aria-labelledby="document Type Label"
      >
        {tenureArray?.map(({ name, value }) => (
          <Box key={value}>
            <FormControlLabel
              label={name}
              value={value}
              control={<Radio />}
              sx={{ width: "100%", ...radioListStyle }}
            />
            {formik?.values?.period === value?.toString() && (
              <Stack
                px={3}
                mt={1}
                alignItems={"center"}
                justifyContent={"space-around"}
                direction={{ xs: "column", sm: "row" }}
              >
                <ButtonComponent
                  onClick={() => {
                    generateSoaReport({
                      appId,
                      period: formik?.values?.period,
                    });
                    setOperationType("download");
                  }}
                  startIcon={<Visibility />}
                >
                  View/Download
                </ButtonComponent>
                <DividerComponent
                  orientation="vertical"
                  variant="middle"
                  sx={{ height: "2em" }}
                />
                <ButtonComponent
                  startIcon={<Email />}
                  onClick={async () => {
                    await generateSoaReport({
                      appId,
                      period: formik?.values?.period,
                    });
                    setOperationType("email");
                    setPollingInterval(null);
                    setOpenEmailModal(true);
                  }}
                >
                  Email
                </ButtonComponent>
              </Stack>
            )}
          </Box>
        ))}
      </RadioGroup>
    </Stack>
  );
};

export default SoaHandler;
